import { defaultRegionInfoProvider } from "./endpoints";
export var ClientSharedValues = {
    apiVersion: "2013-12-02",
    disableHostPrefix: false,
    signingName: "kinesis",
    regionInfoProvider: defaultRegionInfoProvider
};
//# sourceMappingURL=runtimeConfig.shared.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@aws-sdk/client-kinesis/dist/es/runtimeConfig.shared.js
// module id = null
// module chunks = 